// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { IAuditApiParams } from "models/interfaces";

export const getRentalLogs = createAsyncThunk(
  "audit/getRentalLogs",
  async (data: IAuditApiParams) => {
    try {
      const response = await REST.post(
        `/audit/get-rentals-logs?${data.endDate && `endDate=${data.endDate}`}${
          data.lockerId && `&lockerId=${data.lockerId}`
        }${data.page && `&page=${data.page}`}&size=7${
          data.startDate && `&startDate=${data.startDate}`
        }`,
        data.fullName
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getSMSLogs = createAsyncThunk(
  "audit/getSmsLogs",
  async (data: IAuditApiParams) => {
    try {
      const response = await REST.post(
        `/audit/get-sms-logs?${data.endDate && `endDate=${data.endDate}`}${
          data.page && `&page=${data.page}`
        }&size=7${data.startDate && `&startDate=${data.startDate}`}`,
        data.fullName
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getRentalLog = createAsyncThunk(
  "audit/getRentalLog",
  async (rentalId: number) => {
    try {
      const response = await REST.get(
        `/audit/get-rental-log?rentalId=${rentalId}`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);
